import {
  faBell,
  faFileInvoiceDollar,
  faShoppingCart,
  faTag,
  faUserCheck,
} from '@fortawesome/pro-solid-svg-icons';
import type { ReactNode } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import {
  MY_SORARE_FOLLOWS,
  MY_SORARE_OFFERS_RECEIVED,
  MY_SORARE_PLAYERS_NOTIFICATIONS,
  MY_SORARE_PURCHASES_AUCTIONS,
  MY_SORARE_TRANSACTIONS,
} from '@sorare/core/src/constants/__generated__/routes';
import { navLabels } from '@sorare/core/src/lib/glossary';

import { TITLES } from '../common/pages';

type Props = {
  children: ReactNode;
};

const tabsTitles = defineMessages({
  purchases: {
    id: 'MySorareLayout.purchases',
    defaultMessage: 'Purchases',
  },
  offers: {
    id: 'MySorareLayout.offers',
    defaultMessage: 'Offers',
  },
});

const tabs = [
  {
    to: MY_SORARE_OFFERS_RECEIVED,
    icon: faTag,
    label: tabsTitles.offers,
  },
  {
    to: MY_SORARE_PURCHASES_AUCTIONS,
    icon: faShoppingCart,
    label: tabsTitles.purchases,
  },
  {
    icon: faFileInvoiceDollar,
    to: MY_SORARE_TRANSACTIONS,
    label: TITLES.transactions,
  },
  {
    icon: faUserCheck,
    to: MY_SORARE_FOLLOWS,
    label: TITLES.follows,
  },
  {
    icon: faBell,
    to: MY_SORARE_PLAYERS_NOTIFICATIONS,
    label: TITLES.players_notifications,
  },
];

const MySorareTabs = () => {
  return (
    <TabBar variant="flat" fullWidth>
      {tabs.map(tab => (
        <Tab key={tab.to} to={tab.to}>
          <FormattedMessage {...tab.label} />
        </Tab>
      ))}
    </TabBar>
  );
};

export const MySorareLayout = ({ children }: Props) => {
  return (
    <>
      <PageHeader text={navLabels.mySorare} disableBackBrowser />
      <ContentWithStickyHeader header={<MySorareTabs />}>
        {children}
      </ContentWithStickyHeader>
    </>
  );
};
